import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ROUTES_PATHS} from './const/routes';
import {AccessGuardGuard} from "./guards/access-guard.guard";
import {SuperAdminGuard} from "./guards/super-admin.guard";

/* ============================================================= Components Routing */
import {LoginComponent} from './login/login.component';
import {MdpRappelComponent} from './mdp-rappel/mdp-rappel.component';
import {MonCompteComponent} from './mon-compte/mon-compte.component';
import {AgentsComponent} from './agents/agents.component';
import {AgencesComponent} from "./agences/agences.component";
import {EstimationsComponent} from './estimations/estimations.component';
import {ClientsComponent} from './clients/clients.component';
import {TutorielsComponent} from './tutoriels/tutoriels.component';
import {MdpReinitComponent} from './mdp-reinit/mdp-reinit.component';
import {WelcomeComponent} from './welcome/welcome.component';
import {ChoixRenovComponent} from './choix-renov/choix-renov.component';
import {ChoixRenovBisComponent} from './choix-renov-bis/choix-renov-bis.component';
import {BatimentComponent} from './batiment/batiment.component';
import {PiecesComponent} from './pieces/pieces.component';
import {EstimationRapideComponent} from './estimation-rapide/estimation-rapide.component';
import {PieceParPieceComponent} from './piece-par-piece/piece-par-piece.component';
import {SidebarRecapComponent} from './sidebar-recap/sidebar-recap.component';
import {ProduitsComponent} from './produits/produits.component';
import {InscriptionComponent} from './inscription/inscription.component';
import {TransactionComponent} from './transaction/transaction.component';
import {PartenairesComponent} from './partenaires/partenaires.component';
import {SignOnComponent} from "./sign-on/sign-on.component";
import {AllUsersComponent} from "./all-users/all-users.component";
import {ContactExterneComponent} from "./contact-externe/contact-externe.component";
import {RedirectMonCompteGuard} from "./guards/redirect-mon-compte.guard";
import {MyAccountSpaceGuard} from "./guards/my-account-space.guard";

const routes: Routes = [
	{ path: ROUTES_PATHS.LOGIN, component: LoginComponent },
	{ path: ROUTES_PATHS.MDP_RAPPEL, component: MdpRappelComponent },
	{ path: ROUTES_PATHS.MON_COMPTE, component: MonCompteComponent, canActivate: [MyAccountSpaceGuard, RedirectMonCompteGuard] },
	{ path: ROUTES_PATHS.AGENTS, component: AgentsComponent, canActivate: [MyAccountSpaceGuard] },
	{ path: ROUTES_PATHS.AGENCES, component: AgencesComponent, canActivate: [MyAccountSpaceGuard] },
	{ path: ROUTES_PATHS.ESTIMATIONS, component: EstimationsComponent, canActivate: [MyAccountSpaceGuard] },
	{ path: ROUTES_PATHS.CLIENTS, component: ClientsComponent, canActivate: [MyAccountSpaceGuard] },
	{ path: ROUTES_PATHS.TUTORIELS, component: TutorielsComponent },
	{ path: ROUTES_PATHS.MDP_REINIT, component: MdpReinitComponent },
	{ path: ROUTES_PATHS.WELCOME, component: WelcomeComponent },
	{ path: ROUTES_PATHS.CHOIX_RENOV, component: ChoixRenovComponent, canActivate: [AccessGuardGuard] },
	{ path: ROUTES_PATHS.CHOIX_RENOV_BIS, component: ChoixRenovBisComponent, canActivate: [AccessGuardGuard] },
	{ path: ROUTES_PATHS.BATIMENT, component: BatimentComponent, canActivate: [AccessGuardGuard] },
	{ path: ROUTES_PATHS.PIECES, component: PiecesComponent, canActivate: [AccessGuardGuard] },
	{ path: ROUTES_PATHS.ESTIMATION_RAPIDE, component: EstimationRapideComponent },
	{ path: ROUTES_PATHS.PIECE_PAR_PIECE + '/:typeId/:picId', component: PieceParPieceComponent },
	{ path: ROUTES_PATHS.SIDEBAR_RECAP, component: SidebarRecapComponent },
	{ path: ROUTES_PATHS.PRODUITS, component: ProduitsComponent },
	{ path: ROUTES_PATHS.INSCRIPTION, component: InscriptionComponent },
	{ path: ROUTES_PATHS.TRANSACTION, component: TransactionComponent },
	{ path: ROUTES_PATHS.PARTENAIRES, component: PartenairesComponent },
	{ path: ROUTES_PATHS.SIGN_ON, component: SignOnComponent },
	{ path: ROUTES_PATHS.CONTACT_EXTERNE, component: ContactExterneComponent },
	{ path: ROUTES_PATHS.ALL_USERS, component: AllUsersComponent, canActivate: [MyAccountSpaceGuard, SuperAdminGuard] },
	{ path: '**', redirectTo: ROUTES_PATHS.WELCOME },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
